module.exports = __webpack_public_path__ + "img/meeting-location.270e09a0.png";